/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import type {
  Stat,
  TrendDirection,
  TrendTimeframe,
} from 'walden-fast/types/stats';
import { t } from 'walden-fast/utils/intl';

export interface StatCardSignature {
  Args: {
    isDisabled?: boolean;
    stat: Stat;
  };
}

export default class StatCardComponent extends Component<StatCardSignature> {
  get trendDirectionTranslation() {
    const translationKeyMap: Record<TrendDirection, string> = {
      increase: t('components.statCard.trend.direction.increase'),
      decrease: t('components.statCard.trend.direction.decrease'),
      stable: t('components.statCard.trend.direction.stable'),
    };
    return this.args.stat.trend
      ? translationKeyMap[this.args.stat.trend.direction]
      : '';
  }

  get trendTimeframeTranslation() {
    const translationKeyMap: Record<TrendTimeframe, string> = {
      WoW: t('components.statCard.trend.timeframe.pastWeek'),
      MoM: t('components.statCard.trend.timeframe.pastMonth'),
      YoY: t('components.statCard.trend.timeframe.pastYear'),
    };
    return this.args.stat.trend
      ? translationKeyMap[this.args.stat.trend.timeframe]
      : '';
  }
}
